import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../hooks'

type AdminOutletContextType = {
	isAdmin: boolean
	isOwner: boolean
	currentUser: ReturnType<typeof useAuth>['currentUser']
	setCurrentUser: ReturnType<typeof useAuth>['setCurrentUser']
}

const AdminLayout: React.FC = () => {
	const { isAdmin, isOwner, currentUser, setCurrentUser } = useAuth()

	if (currentUser && !isAdmin) {
		return <Navigate to="/" replace />
	}

	const outletContext: AdminOutletContextType = {
		isAdmin,
		isOwner,
		currentUser,
		setCurrentUser,
	}

	return (
		<div className="bg-white dark:bg-background-dark flex flex-col items-center h-full">
			<Outlet context={outletContext} />
		</div>
	)
}

export default AdminLayout
